export const BULK_INVITE_REQUEST = 'BULK_INVITE_REQUEST';
export const BULK_INVITE_REQUEST_FAILURE = 'BULK_INVITE_REQUEST_FAILURE';
export const BULK_INVITE_REQUEST_SUCCESS = 'BULK_INVITE_REQUEST_SUCCESS';

export const GET_TEAM_REQUEST = 'GET_TEAM_REQUEST';
export const GET_TEAM_REQUEST_FAILURE = 'GET_TEAM_REQUEST_FAILURE';
export const GET_TEAM_REQUEST_SUCCESS = 'GET_TEAM_REQUEST_SUCCESS';

export const INVITE_USER_REQUEST = 'INVITE_USER_REQUEST';
export const INVITE_USER_REQUEST_FAILURE = 'INVITE_USER_REQUEST_FAILURE';
export const INVITE_USER_REQUEST_SUCCESS = 'INVITE_USER_REQUEST_SUCCESS';
